import React from 'react';
import {
    allStaffVisitsReportID,
    loginActivityReportID,
    powerBIBase,
    staffMemberVisitsReportID
} from '../../../config/PowerBiReportConfig';
import { appBaseURL } from '../../../config/URLConfig';

export const StaffMemberReport = ({ username }) => {

    const handleViewAllStaffVisitsReportClick = async () => {
        window.open(`${powerBIBase}${allStaffVisitsReportID}/ReportSection`);
    }

    const handleViewStaffMemberVisitsReportClick = async () => {
        window.open(`${powerBIBase}${staffMemberVisitsReportID}/ReportSection`);
    }

    const handleViewLoginActivityReportClick = async () => {
        window.open(`${powerBIBase}${loginActivityReportID}/ReportSection`);
    }

    const handleDownloadAllStaffVisitsExcelClick = async () => {
        window.open(`${appBaseURL}/api/all-staff-visits-report?username=${username}`);
    }

    const handleDownloadStaffMemberVisitsExcelClick = async () => {
        window.open(`${appBaseURL}/api/staff-member-visits-report?username=${username}`);
    }

    const handleDownloadLoginActivityExcelClick = async () => {
        window.open(`${appBaseURL}/api/login-activity-report?username=${username}`);
    }

    return (
        <div>
            <h2 className="report-header">Staff Member Report</h2>
            <div className="report-button-container">
                <div className={ 'report-button' } onClick={ handleViewAllStaffVisitsReportClick }>
                    All Staff Visits Report
                </div>
                <div className={ 'report-button' } onClick={ handleDownloadAllStaffVisitsExcelClick }>
                    Download Excel
                </div>
            </div>
            <div className="report-button-container">
                <div className={ 'report-button' } onClick={ handleViewStaffMemberVisitsReportClick }>
                    Staff Member Visits Report
                </div>
                <div className={ 'report-button' } onClick={ handleDownloadStaffMemberVisitsExcelClick }>
                    Download Excel
                </div>
            </div>
            <div className="report-button-container">
                <div className={ 'report-button' } onClick={ handleViewLoginActivityReportClick }>
                    Login Activity
                </div>
                <div className={ 'report-button' } onClick={ handleDownloadLoginActivityExcelClick }>
                    Download Excel
                </div>
            </div>
        </div>
    );
}
